import { render, staticRenderFns } from "./OrderHistroy.html?vue&type=template&id=2a9e88f8&scoped=true&"
import script from "./OrderHistroy.ts?vue&type=script&lang=ts&"
export * from "./OrderHistroy.ts?vue&type=script&lang=ts&"
import style0 from "./OrderHistroy.css?vue&type=style&index=0&id=2a9e88f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9e88f8",
  null
  
)

export default component.exports